import cn from '@/utilities/cn'

import LoadingSpinner from './LoadingSpinner'

interface ButtonModalProps {
  disabled?: boolean
  loading?: boolean
  variant?: 'error' | 'warning' | 'success' | 'info'
  onConfirm: () => void
  loadingText?: string
  confirmText: string
}

export default function ButtonModal({
  disabled = false,
  loading = false,
  variant,
  onConfirm,
  loadingText = 'Loading...',
  confirmText
}: ButtonModalProps) {
  return (
    <button
      type="button"
      disabled={disabled || loading}
      className={cn(
        'inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold text-white shadow-sm sm:ml-3 sm:w-auto',
        {
          'cursor-not-allowed bg-zinc-100 opacity-50': disabled,
          'bg-red-600 hover:bg-red-500 focus-visible:outline-red-600': variant === 'error',
          'bg-yellow-600 hover:bg-yellow-500 focus-visible:outline-yellow-600': variant === 'warning',
          'bg-green-600 hover:bg-green-500 focus-visible:outline-green-600': variant === 'success',
          'bg-brand-400 hover:bg-brand-300 focus-visible:outline-brand-400': variant === 'info'
        }
      )}
      onClick={() => onConfirm()}
    >
      {loading ? (
        <div className="flex gap-x-2">
          <LoadingSpinner variant={variant} className="h-6 w-6" />
          <div>{loadingText}</div>
        </div>
      ) : (
        confirmText
      )}
    </button>
  )
}
